import React, { useEffect, useState } from 'react';
import classes from './styles.module.css';
import { ApplicationView, useController } from '@aha-app/mvc';
import Confirm from 'components/common/Confirm';
import WhiteboardContainerController from './WhiteboardContainerController';
import { Link } from './Router';

interface ContainerHeaderProps {
  editor: any;
  node: any;
}

const ContainerHeader: React.FC<ContainerHeaderProps> = ({ editor, node }) => {
  const controller = useController(WhiteboardContainerController);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { unresolvedCommentsCount } = controller.state;
  const fullScreenUrl = controller.getDisplayModeUrl('fullscreen');
  const commentsUrl = controller.getDisplayModeUrl(
    'fullscreen',
    '#sidepanel-comments'
  );

  function removeWhiteboard() {
    editor = editor.removeNodeByKey(node.key);
  }

  useEffect(() => {
    void controller.actionUpdateUnresolvedCommentCount();
  }, [controller]);

  return (
    <div className={classes.topbar}>
      <div className={classes.topbar__content}>
        <div className={classes.topbar__name}>
          Double-click to view or edit in full-screen mode
        </div>

        <div className={classes.topbar__controls}>
          {unresolvedCommentsCount && unresolvedCommentsCount > 0 && (
            <Link
              router={controller.router}
              to={commentsUrl}
              className={classes.topbar__commentButton}
              data-aha-editor-not-new-window='true'
            >
              <i className='fa-solid fa-comment' />
              <span>{unresolvedCommentsCount}</span>
            </Link>
          )}
          <Link
            router={controller.router}
            to={fullScreenUrl}
            data-aha-editor-not-new-window='true'
          >
            <i className='fa-solid fa-pencil' />
          </Link>
          <button role='button' onClick={() => setConfirmDelete(true)}>
            <i className='fa-regular fa-trash-can' />
          </button>
        </div>
      </div>
      <Confirm
        confirmText='Yes, delete this whiteboard'
        title='Warning'
        body={'Are you sure you want to delete this whiteboard?'}
        iconUrl='/exclamation.png'
        visible={confirmDelete}
        showOpenButton={false}
        onConfirm={removeWhiteboard}
        onClose={() => setConfirmDelete(false)}
        confirmButtonStyle='danger'
        aria-label='delete whiteboard confirmation'
      />
    </div>
  );
};

export default ApplicationView(ContainerHeader);
